import React, { memo } from "react";
import { Divider } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { Badge } from "../preview/Badge";
import { AccomodationSummary } from "./AccomodationSummary";
import { ParticipantFullSummary } from "../../types/participant.types";
import { RegistrationRequest } from "../../types/registration.types";
import { ConferenceConfiguration } from "../../types/conference.types";
import {
  Accomodation,
  AccomodationSummary as AccomodationSummaryType,
} from "../../types/accomodation.types";
import type { ParticipantSummaryChanges } from "./participantSummarySectionTypes";

export interface ParticipantSummaryAccommodationSectionProps {
  participant: ParticipantFullSummary;
  modifiedData: RegistrationRequest | null | undefined;
  displayConfigJson: ConferenceConfiguration;
  changes: ParticipantSummaryChanges;
  allAccomodations: Accomodation[];
}

const ParticipantSummaryAccommodationSectionInner: React.FC<
  ParticipantSummaryAccommodationSectionProps
> = ({
  participant,
  modifiedData,
  displayConfigJson,
  changes,
  allAccomodations,
}) => {
  const registrationConfigJson = participant.congressEvent.configJson;

  const hasModifiedHotelBookingData = !!modifiedData?.hotelBooking;
  const showAccommodationSection =
    participant.hotelBooking != null ||
    (registrationConfigJson.accommodationEnabled && !modifiedData) ||
    (!!modifiedData &&
      displayConfigJson.accommodationEnabled &&
      hasModifiedHotelBookingData);

  if (!showAccommodationSection) return null;

  let accommodationBody: React.ReactNode;
  if (changes["hotelBooking"] !== undefined && modifiedData?.hotelBooking) {
    const modifiedHotel = allAccomodations.find(
      (a) => a.id === modifiedData.hotelBooking?.hotelId,
    );
    if (modifiedData.hotelBooking) {
      const modifiedRoom = modifiedHotel?.hotelRoomList?.find(
        (r) => r.id === modifiedData.hotelBooking?.roomId,
      );
      const modifiedAccomodationSummary: AccomodationSummaryType = {
        id: participant.hotelBooking?.id || 0,
        hotelName: modifiedHotel?.name || "",
        hotelRoomName: modifiedRoom?.name || "",
        arrivalDate: modifiedData.hotelBooking.arrivalDate || "",
        departureDate: modifiedData.hotelBooking.departureDate || "",
        numberOfNights: modifiedData.hotelBooking.noNights || 0,
        roomMateName: modifiedData.hotelBooking.roomMate,
        price: modifiedRoom?.price || 0,
      };
      accommodationBody = (
        <AccomodationSummary
          accomodationSummary={modifiedAccomodationSummary}
          originalSummary={participant.hotelBooking}
        />
      );
    } else {
      accommodationBody = (
        <AccomodationSummary accomodationSummary={participant.hotelBooking} />
      );
    }
  } else {
    accommodationBody = (
      <AccomodationSummary accomodationSummary={participant.hotelBooking} />
    );
  }

  return (
    <>
      <Badge color="green">
        <Trans>Accomodation</Trans>
      </Badge>
      {accommodationBody}
      <Divider />
    </>
  );
};

export const ParticipantSummaryAccommodationSection = memo(
  ParticipantSummaryAccommodationSectionInner,
);
